import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 bg-surface" data-id="element-10">
      <div className="max-w-7xl mx-auto px-6" data-id="element-11">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-12">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} data-id="element-13">
            <h2 className="text-3xl md:text-4xl font-semibold mb-6" data-id="element-14">Про нас</h2>
            <p className="text-lg text-secondary leading-relaxed mb-6 font-medium text-primary" data-id="element-15">
              Ми не ведемо розлучення, ДТП чи бізнес-спори. Тільки військове
              право.
            </p>
            <p className="text-lg text-secondary leading-relaxed" data-id="element-16">
              З 2022 року ми провели понад 500 справ, пов'язаних з мобілізацією,
              ВЛК та службою. За цей час ми вивчили не лише законодавство — ми
              знаємо внутрішню кухню ТЦК у різних областях, позиції конкретних
              суддів адмінсудів, типові помилки ВЛК, які можна використати для
              оскарження.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6" data-id="element-17">
            <div className="bg-background p-8 rounded-3xl border border-border flex flex-col justify-between min-h-[180px] hover:border-primary/30 transition-colors" data-id="element-18">
              <div className="text-4xl font-semibold text-primary mb-4" data-id="element-19">
                з 2022
              </div>
              <div className="text-sm text-secondary leading-relaxed" data-id="element-20">
                Спеціалізуємось виключно на військовому праві
              </div>
            </div>

            <div className="bg-background p-8 rounded-3xl border border-border flex flex-col justify-between min-h-[180px] hover:border-primary/30 transition-colors" data-id="element-21">
              <div className="text-4xl font-semibold text-primary mb-4" data-id="element-22">
                24/7
              </div>
              <div className="text-sm text-secondary leading-relaxed" data-id="element-23">
                На зв'язку для термінових питань
              </div>
            </div>

            <div className="bg-background p-8 rounded-3xl border border-border flex flex-col justify-between min-h-[180px] hover:border-primary/30 transition-colors" data-id="element-24">
              <div className="text-4xl font-semibold text-primary mb-4" data-id="element-25">
                500+
              </div>
              <div className="text-sm text-secondary leading-relaxed" data-id="element-26">
                Військовослужбовців відстояли свої права
              </div>
            </div>

            <div className="bg-background p-8 rounded-3xl border border-border flex flex-col justify-between min-h-[180px] hover:border-primary/30 transition-colors" data-id="element-27">
              <div className="text-4xl font-semibold text-primary mb-4" data-id="element-28">
                100%
              </div>
              <div className="text-sm text-secondary leading-relaxed" data-id="element-29">
                Конфіденційно. Дані захищені адвокатською таємницею
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}